// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IokC","col":"styles_col__1tlY4","actions":"styles_actions__3eIEN","conflict":"styles_conflict__3ltGi"};